<div id="i3-dc-container">
    <div id="i3-dc-detail" class="prevent-select">
        <div id="i3-dc-title">{{ title | translate }}</div>
        <div id="i3-dc-value">{{ value | translate }}</div>
    </div>
</div>
